import { useCallback } from 'react';
import { useIsRTL, useLanguage } from '../../../../locale';
import { forceLtr } from '../../../../locale/useBidiFormatter';
export const useHexBidiFormatter = () => {
  const isRTL = useIsRTL();
  const lang = useLanguage();
  return useCallback((hexValue, options) => {
    return isRTL && (['ar', 'ar-xx', 'he', 'iw'].includes(lang.toLowerCase()) || options?.forceLtrDir) ? forceLtr(hexValue) : hexValue;
  }, [isRTL, lang]);
};
//# sourceMappingURL=useHexBidiFormatter.js.map